import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function resultsReducer(state = initialState.results, action) {
	//avoiding state mutation, while updating nested states.
	switch (action.type) {
		case types.SET_ASSETS3D_DATA:
			return {
				...state,
				assets3dData: {
					count: action.data.count,
					data: action.data.data,
				},
			};
		case types.SET_PRODUCTS_DATA:
			return {
				...state,
				productsData: {
					count: action.data.count,
					data: action.data.data,
				},
			};
		case types.RESET_RESULTSVIEW_DATA:
			return {
				...state,
				productsData: {
					count: 0,
					data: [],
				},
				assets3dData: {
					count: 0,
					data: [],
				},
				assetFilters: {
					isBuyable: true,
					isArchived: false,
					tags: [],
				},
				productFilters: {
					isBuyable: true,
				},
				assetFilterCount: {
					archived: 0,
					buyable: 0,
				},
				productFilterCount: {
					buyable: 0,
				},
			};
		case types.SET_ASSET_FILTERS:
			return {
				...state,
				assetFilters: {
					isBuyable: action.data.isBuyable,
					isArchived: action.data.isArchived,
					tags: action.data.tags,
				},
			};
		case types.SET_PRODUCT_FILTERS:
			return {
				...state,
				productFilters: {
					isBuyable: action.data.isBuyable,
				},
			};
		case types.SET_ASSET_FILTER_COUNT:
			return {
				...state,
				assetFilterCount: {
					archived: action.data.archived,
					buyable: action.data.buyable,
				},
			};
		case types.SET_PRODUCT_FILTER_COUNT:
			return {
				...state,
				productFilterCount: {
					buyable: action.data.buyable,
				},
			};
		default:
			return state;
	}
}
